import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  
  // Replace with your actual WhatsApp number (include country code, no spaces or special characters)
  const phoneNumber = "919400483231"; // Using the number from your image: 9400-483231
  const message = "Hi! I'm interested in your online tutoring services. Can you tell me more about the programs at NOVA?";

  const handleWhatsAppClick = () => {
    // Format: https://wa.me/919400483231?text=YourMessage
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  // Auto-hide tooltip after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsTooltipVisible(false);
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [isTooltipVisible]);

  // Show tooltip on mount
  useEffect(() => {
    setIsTooltipVisible(true);
  }, []);

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Pre-written Message Options Card (Optional) */}
      {isTooltipVisible && (
        <div className="absolute bottom-full right-0 mb-4 animate-fade-in-up">
          <div className="bg-white rounded-2xl shadow-2xl p-4 w-72 border border-gray-100">
            {/* Close button */}
            <button 
              onClick={() => setIsTooltipVisible(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
            >
              <X size={16} />
            </button>
            
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                <MessageCircle size={20} className="text-green-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-800 text-sm">Chat with us</p>
                <p className="text-xs text-gray-500">Typically replies within 5 mins</p>
              </div>
            </div>
            
            <p className="text-sm text-gray-600 mb-3">
              👋 Hi! How can we help you today?
            </p>
            
            <div className="space-y-2">
              <button 
                onClick={() => {
                  const quickMessage = "I'm interested in one-to-one tutoring. Can you share more details?";
                  window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(quickMessage)}`, '_blank');
                }}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-2 rounded-lg transition-colors"
              >
                📚 Interested in one-to-one tutoring
              </button>
              <button 
                onClick={() => {
                  const quickMessage = "I want to become a tutor at NOVA. What are the requirements?";
                  window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(quickMessage)}`, '_blank');
                }}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-2 rounded-lg transition-colors"
              >
                👨‍🏫 Want to become a tutor
              </button>
              <button 
                onClick={() => {
                  const quickMessage = "I need help with Physics/Math. Can you assist?";
                  window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(quickMessage)}`, '_blank');
                }}
                className="w-full text-left text-sm bg-gray-50 hover:bg-gray-100 p-2 rounded-lg transition-colors"
              >
                🔬 Need help with a specific subject
              </button>
            </div>
            
            {/* Tooltip arrow */}
            <div className="absolute -bottom-2 right-4 w-4 h-4 bg-white rotate-45 border-r border-b border-gray-100"></div>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setIsTooltipVisible(true)}
        className="relative btn btn-circle btn-lg bg-green-500 hover:bg-green-600 border-none shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-110"
        aria-label="Contact us on WhatsApp"
      >
        <MessageCircle size={28} className="text-white" />
        
        {/* Notification Badge */}
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full border-2 border-white animate-pulse"></span>
      </button>

      {/* Pulse Animation Ring */}
      <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-30 pointer-events-none"></div>
      
      {/* Second Pulse Ring for more visibility */}
      <div className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-20 pointer-events-none" style={{ animationDelay: '1s' }}></div>

      {/* Add custom animations */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fade-in-up {
          animation: fadeInUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default WhatsAppButton;